import PropTypes from 'prop-types';
import classNames from 'classnames';
import { trans } from '@spotahome/soyuz/client';

import './Table.scss';

const DEFAULT_LABEL_KEYS = ['chart.table.month', 'chart.table.average.price'];

const Table = ({
  data,
  valueKey = 'value',
  labelKeys = DEFAULT_LABEL_KEYS,
  formatValue = value => value
}) => {
  const columns = [
    { key: 'label', label: trans(labelKeys[0]), isRight: false },
    { key: valueKey, label: trans(labelKeys[1]), isRight: true }
  ];

  const getTableChangeClasses = item =>
    classNames('chart-table__change', {
      'chart-table__change--green': item.delta > 0,
      'chart-table__change--red': item.delta < 0
    });

  return (
    <table className="chart-table">
      <thead>
        <tr>
          {columns.map(({ label, isRight }, index) => (
            <th
              key={`header-${index}`}
              scope="col"
              className={isRight ? 'chart-table__cell--right' : ''}
            >
              {label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIndex) => (
          <tr key={`row-${rowIndex}`}>
            {columns.map(({ key, label, isRight }, colIndex) => {
              const value = key === valueKey ? formatValue(row[key]) : row[key];
              const showDelta = key === valueKey && row.delta;

              return (
                <td
                  key={`cell-${rowIndex}-${colIndex}`}
                  className={isRight ? 'chart-table__cell--right' : ''}
                  data-label={label}
                >
                  {showDelta ? (
                    <>
                      {value}
                      <span className={getTableChangeClasses(row)}>
                        ({row.delta}%)
                      </span>
                    </>
                  ) : (
                    value
                  )}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

Table.propTypes = {
  valueKey: PropTypes.string,
  labelKeys: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      delta: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ).isRequired,
  formatValue: PropTypes.func
};

export default Table;
